import * as React from 'react'

import { GROWTH_DIAGNOSTIC_CLASS_SUMMARY } from '../asset_constants'

const GrowthDiagnosticSlide = ({ slideGroupClassName, }) => (
  <section className={`slide ${slideGroupClassName} growth-diagnostic-slide`} key="growth-diagnostic-slide">
    <div>
      <h1>Measure impact with a Growth Diagnostic</h1>
      <p>Once students complete their practice activities, use a Growth Diagnostic to measure their growth over the course of the school year.</p>
      <img alt="Screenshot of the Class Summary from the My Diagnostics Growth report, showing that Students had overall growth of 37% in Compound-Complex Sentences this school year." src={GROWTH_DIAGNOSTIC_CLASS_SUMMARY} />
    </div>
  </section>
)

export default GrowthDiagnosticSlide
